
$(document).on('initialized.ocms.ultimate-form', (event, form) => {
  if (OCMS.GlobalVars.Brand === 'mel' && form !== undefined && form !== null && form.id === 'shipping') {
    const HongKongSpecificConfigureShippingMethod = () => {
      const list = $("[data-id='shippingMethodList']");
      list.find('.rdblistShippingMethodStep3 input').attr('disabled', true);
      list.find('.rdblistShippingMethodStep3 input').attr('checked', false);
      const selectedIndex = form.countryField.prop('selectedIndex');
      $(`.rdblistShippingMethodStep3[index='${selectedIndex}'] input`).prop('disabled', false);
      list.find('.rdblistShippingMethodStep3 input:radio').trigger('change');
    };

    HongKongSpecificConfigureShippingMethod();
    form.countryField.on('change', HongKongSpecificConfigureShippingMethod);
  }
});



// WEBPACK FOOTER //
// ./js/countryForm/hong-kong.form.js